import cmsFallbackReferalSchema from './referAndEarnFallbackSchema';
import processCmsData from './index';
import { DEFAULT_SCHEMA, EU } from '../constants';

const InviteEarnProductType = {
  AMAZE: 'AMAZE',
  REMITTANCE: 'REMITTANCE'
};

export function getReferralCMSSpecificToCountry(
  referralScreenSchema,
  country_code,
  isAmazeUser,
  isRemittanceUser
) {
  const userCountryCode = EU.includes(country_code) ? 'EU' : country_code;
  const cmsCustomCountryContent = [];
  if (referralScreenSchema) {
    const filteredCmsContent = referralScreenSchema?.referEarnData?.value;
    if (filteredCmsContent) {
      const isCountryInCms = filteredCmsContent.find((ele) => {
        const supportingCountryCode = ele?.target?.fields?.supportingCountryCode?.value;
        const productType = ele?.target?.fields?.productType?.value;

        if (country_code === 'SG' && supportingCountryCode === 'SG') {
          /** If countryCode is 'SG' then only below 3 schemas needs to be rendered based on productType.
           * 1. INVITE_EARN_SG -> If both (Amaze & Remittance) or new users with no txns.
           * 2. INVITE_EARN_SG_AMAZE -> If users have an amaze card with no remittance txns.
           * 3. INVITE_EARN_SG_REMITTANCE -> If user did remittance txns and doesn't have amaze.
           */
          const isBothOrNewUser =
            (isAmazeUser && isRemittanceUser) || (!isAmazeUser && !isRemittanceUser);
          const isAmazeOnlyUser = isAmazeUser && !isRemittanceUser;
          const isRemittanceOnlyUser = !isAmazeUser && isRemittanceUser;
          const hasAmazeProduct = productType?.includes(InviteEarnProductType.AMAZE);
          const hasRemittanceProduct = productType?.includes(InviteEarnProductType.REMITTANCE);
          return (
            (isBothOrNewUser && hasAmazeProduct && hasRemittanceProduct) ||
            (isAmazeOnlyUser && hasAmazeProduct && !hasRemittanceProduct) ||
            (isRemittanceOnlyUser && !hasAmazeProduct && hasRemittanceProduct)
          );
        }
        return supportingCountryCode === userCountryCode;
      });
      if (isCountryInCms) {
        cmsCustomCountryContent.push(isCountryInCms?.target?.fields);
      } else {
        for (const ele of filteredCmsContent) {
          if (ele?.target?.fields?.supportingCountryCode?.value === DEFAULT_SCHEMA) {
            cmsCustomCountryContent.push(ele?.target?.fields);
            break;
          }
        }
      }
    }
  }

  return cmsCustomCountryContent.length
    ? processCmsData(cmsCustomCountryContent[0])
    : cmsFallbackReferalSchema;
}
